export default __webpack_public_path__ + "static/media/capex-logo.0ff1e84c.svg";